import React from 'react';
import { Typography } from '@mui/material';

import './date-climate-model.styles.scss';

export default function DateClimateModel() {
  return (
    <div className='date-climate-model-container'>
      <Typography variant='h5' component='h2' id='date-climate-model-label'>
        Climate Model Time Frame
      </Typography>
      <Typography variant='p' id='date-climate-model-dates'>
        <b>{new Date().getFullYear()}</b> to <b>2099</b>
      </Typography>
    </div>
  );
}
